module.exports = __webpack_public_path__ + "img/cns_mac10.1fabda96.png";